import { defineStore } from 'pinia'
import type { AffiliateDetails } from '../types/model/index'

function initState(): {
  affiliateDetails: AffiliateDetails | null
  isOpenAffiliateModal: boolean
  isOpenAffiliateTransactionsModal: boolean
  pendingAffiliateModal: boolean
  isLoading: boolean
} {
  return {
    affiliateDetails: null,
    isOpenAffiliateModal: false,
    isOpenAffiliateTransactionsModal: false,
    pendingAffiliateModal: false,
    isLoading: true,
  }
}

const useAffiliateStore = defineStore('affiliate', {
  state: () => ({ ...initState() }),
  actions: {
    toggleAffiliateModal() {
      this.isOpenAffiliateModal = !this.isOpenAffiliateModal
    },
    setAffiliateDetails(details: AffiliateDetails) {
      this.affiliateDetails = details
    },
    toggleAffiliateTransactionsModal() {
      this.isOpenAffiliateTransactionsModal =
        !this.isOpenAffiliateTransactionsModal
    },
    setNotRegisteredAffiliateModal(pending: boolean) {
      this.pendingAffiliateModal = pending
    },
    openAffiliateModal() {
      if (this.pendingAffiliateModal) {
        this.pendingAffiliateModal = false
        this.isOpenAffiliateModal = true
      }
    },
    setIsLoading(value: boolean) {
      this.isLoading = value
    },
    reset() {
      this.$reset()
    },
  },
  persist: {
    storage: window.localStorage,
    paths: ['pendingAffiliateModal'],
  },
})

export default useAffiliateStore
